import { Pipe, PipeTransform } from '@angular/core';
const _ = require('../../../node_modules/lodash/index');

@Pipe({name: 'label'})
export class LabelPipe implements PipeTransform {
    public transform(value: any, property: string, collection: any): string|void {
        let find = {};
        find[property] = value;
        let obj = _.find(collection, find);

        return obj && obj.label;
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/pipe/label.pipe.ts